const ICONS = {
  success: (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' aria-hidden='true'>
      <circle cx='10' cy='10' r='10' fill='currentColor' opacity='.15' />
      <path d='M6 10l3 3 5-5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  ),
  error: (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' aria-hidden='true'>
      <circle cx='10' cy='10' r='10' fill='currentColor' opacity='.15' />
      <path d='M7 7l6 6M13 7l-6 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
  ),
  warning: (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' aria-hidden='true'>
      <circle cx='10' cy='10' r='10' fill='currentColor' opacity='.15' />
      <path d='M10 6v5M10 14h.01' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
  ),
  info: (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' aria-hidden='true'>
      <circle cx='10' cy='10' r='10' fill='currentColor' opacity='.15' />
      <path d='M10 9v5M10 7h.01' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
  ),
};

export default ICONS;
